import type { PathLookupPassingTraffic } from '@ipfabric/utils';

type PassingTrafficResult = 'pass' | 'fail' | 'error';

export const getPassingTrafficResult = (
  passingTraffic: PathLookupPassingTraffic | null,
  expectedPassingTraffic: PathLookupPassingTraffic | null,
): PassingTrafficResult => {
  if (passingTraffic === 'error') {
    return 'error';
  }
  /*
   * Passing/Failing depends on expectation
   * passingTraffic === all => pass, passingTraffic === none => fail
   * expectedPassingTraffic === all && passingTraffic === part => fail
   * expectedPassingTraffic === none && passingTraffic === part => pass
   */
  if (expectedPassingTraffic === 'all') {
    return passingTraffic === 'all' ? 'pass' : 'fail';
  }
  return passingTraffic === 'none' ? 'fail' : 'pass';
};
